import { IBillToAccountObj } from 'src/interface'

export const dispatchGetCartAfterLogin = (billToAccountObj: IBillToAccountObj, customerId: string) => {
  window.dispatchEvent(
    new CustomEvent('getCartAfterLogin', { detail: { BillToAccountObj: billToAccountObj, customerId } })
  )
}
